import { Injectable } from '@angular/core';
import { Account, Client } from 'appwrite';
import { environment } from '../../../../environments/environment';

interface Log {
  date: Date;
  method: string;
  path: string;
  status: number;
  response: string;
}
@Injectable({ providedIn: 'root' })
export class AppwriteService {
  detailHeight: number = 0;
  private resizeObserver!: ResizeObserver;
  logs: Log[] = [];
  status: 'idle' | 'loading' | 'success' | 'error' = 'idle';
  showLogs: boolean = false;

  private client = new Client().setEndpoint(environment.appwriteUrl).setProject(environment.appwriteProjectId);

  private account = new Account(this.client);

  get accountInstance() {
    return this.account;
  }

  constructor() {
    this.sendPing();
  }

  async sendPing() {
    if (this.status === 'loading') return;
    this.status = 'loading';

    try {
      const result = await this.client.ping();
      const log: Log = {
        date: new Date(),
        method: 'GET',
        path: '/v1/ping',
        status: 200,
        response: JSON.stringify(result),
      };
      this.logs = [log, ...this.logs];
      this.status = 'success';
    } catch (err: any) {
      const log: Log = {
        date: new Date(),
        method: 'GET',
        path: '/v1/ping',
        status: err instanceof Error ? 500 : err.code,
        response: err instanceof Error ? 'Something went wrong' : err.message,
      };
      this.logs = [log, ...this.logs];
      this.status = 'error';
    }
    this.showLogs = true;
  }

  async logout() {
    try {
      await this.account.deleteSession({ sessionId: 'current' });
    } catch (err: any) {
      console.error('Logout failed', err);
    }
  }
}
